import React, { useState } from 'react'

export default function EditCell({
  value: initialValue = '',
  warningMsg,
  onUpdate,
  style,
  emptyAllowed = true,
  disabled,
}) {
  const [value, setValue] = useState('')
  const [editing, setEditing] = useState(false)

  const tryUpdate = () => {
    if (
      initialValue !== value &&
      (emptyAllowed || (!emptyAllowed && value)) &&
      (!warningMsg || (warningMsg && window.confirm(warningMsg)))
    ) {
      onUpdate(value.trim())
    }
  }

  return (
    <div className="" style={{ minWidth: '100px', ...style }}>
      <input
        className=""
        style={{
          border: 'none',
          width: '100%',
          background: 'none',
          ...(disabled && {
            cursor: 'not-allowed',
          }),
        }}
        disabled={disabled}
        value={editing ? value : initialValue}
        onChange={e => setValue(e.target.value)}
        onFocus={() => {
          setEditing(true)
          setValue(initialValue)
        }}
        onBlur={() => {
          tryUpdate()
          setEditing(false)
        }}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            e.target.blur()
          }
        }}
      />
    </div>
  )
}
